import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { DevicesComponent } from './devices.component';
import { MatAutocompleteModule, MatExpansionModule } from '@angular/material';
import { PipesModule } from '../../pipes/pipes.module';
import { AddDeviceDialogComponent } from './add-device/add-device-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { AddLabelDialogComponent } from './add-label/add-label-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    PipesModule,
    MatExpansionModule,
    MaterialModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [DevicesComponent, AddDeviceDialogComponent, AddLabelDialogComponent],
  entryComponents: [AddDeviceDialogComponent, AddLabelDialogComponent]
})
export class DevicesModule {}



// WEBPACK FOOTER //
// ./src/app/modules/devices/devices.module.ts